import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { apiService } from '../../../services/api.service';
import { globalData } from '../../../services/globalData.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  @ViewChild('inputA') inputA: ElementRef;
  @ViewChild('inputB') inputB: ElementRef;
  @ViewChild('inputC') inputC: ElementRef;
  @ViewChild('inputD') inputD: ElementRef;
  @ViewChild('inputE') inputE: ElementRef;
  @ViewChild('inputF') inputF: ElementRef;
  loginOTP: string = '';
  otpSentOnText: string = '';
  otpSentText: string = '';
  myForm: FormGroup;
  myFormPassword: FormGroup;
  isOTPSend = false;
  resetPassword = true;
  enterOTP = false;
  setNewPassword = false;
  VerifyOTPToken: string = '';
  @Output() childButtonEventOtpSent = new EventEmitter();
  @Output() childButtonEventEnterOtp = new EventEmitter();
  @Output() childButtonEventNewPassword = new EventEmitter();
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  IsVerifyOTP: boolean = true;
  @Output() countryCodeSelected: EventEmitter<string> = new EventEmitter<string>();
  isOpen: boolean = false;
  selectedCountryCode: string = ''; // Default selected country code
  mobileNoMaxLength: number = 10;
  isCountrySelected: boolean = false;
  countryCodes: any[] = [];
  isMobileNumberTabActive: boolean = true;
  isEmailTabActive: boolean = false;
  mobileNo_Or_Email: string = '';

  pwdMinLength: number = 0;
  pwdUpperCaseLength: number = 0;
  pwdLowerCaseLength: number = 0;
  pwdNumericCharLength: number = 0;
  pwdPsecialCharLength: number = 0;
  pwdAlphaNumericharLength: number = 0;

  constructor(private _apiService: apiService, public global: globalData) {

  }

  ngOnInit() {
    this.isOpen = false;
    this.selectedCountryCode = '+1';

    this.myForm = new FormGroup({
      mobile: new FormControl('', Validators.required),
      email: new FormControl('', Validators.email),
      searchText: new FormControl('')
    });

    this.myFormPassword = new FormGroup({
      password: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required)
    });

    this.GetCountryList();
  }

  GetCountryList() {

    var searchText = this.myForm.value.searchText;

    this.global.GetCountryList(searchText).then((countryCodes: any[]) => {
      this.countryCodes = countryCodes;

      if (!this.isCountrySelected && this.countryCodes.length > 0) {

        var country = this.countryCodes.find(item => item.iso_code === this.global.customerCountryCode);
        if (country) {
          this.selectedCountryCode = country.isd_code;
          this.mobileNoMaxLength = country.mobNo_length;
        }
        else {
          this.selectedCountryCode = this.countryCodes[0].isd_code;
          this.mobileNoMaxLength = this.countryCodes[0].mobNo_length;
        }
      }
    });
  }

  onInputChange(inputElement: any): void {
    const inputValue = inputElement.value;
    const maxLength = inputElement.maxLength;

    if (inputValue.length === maxLength) {
      // Focus on the next input element
      const nextInput = inputElement.nextElementSibling;
      if (nextInput instanceof HTMLInputElement) {
        nextInput.focus();
      }
    }
  }

  sendVerificationOTP() {
    this.isOTPSend = true;
    this.resetPassword = false;
    this.enterOTP = false;

    const headers = { "Content-Type": "application/json" };

    const paramSendOTP = {
      "type": this.isMobileNumberTabActive ? 'mobile' : 'email',
      "isd_code": this.selectedCountryCode,
      "mobile_or_email": this.mobileNo_Or_Email,
      "language_code": localStorage.getItem('languageCode')
    }

    this._apiService.sendForgotPwdOTP(paramSendOTP, headers).subscribe(resp => {
      if (resp.success == true) {
        this.isOTPSend = false;
        this.enterOTP = true;
        this.loginOTP = resp.data[0].otp;


        this.loginOTP = String(resp.data[0].otp);
        this.IsVerifyOTP = resp.data[0].otp_verify;

        let otpDigits: string[] = [];

        for (let i = 0; i < this.loginOTP.length; i++) {
          otpDigits.push(this.loginOTP[i]);
        }

        if (otpDigits.length > 0) {
          setTimeout(() => {
            if (!this.IsVerifyOTP) {
              this.inputA.nativeElement.value = otpDigits[0];
              this.inputB.nativeElement.value = otpDigits[1];
              this.inputC.nativeElement.value = otpDigits[2];
              this.inputD.nativeElement.value = otpDigits[3];
              this.inputE.nativeElement.value = otpDigits[4];
              this.inputF.nativeElement.value = otpDigits[5];
            }
          }, 200);
        }

        this.childButtonEventOtpSent.emit('OTP Sent');
      }
      else {
        alert("Error occur while sending OTP.");
        this.isOTPSend = false;
        this.closeModal.emit();
      }
    });
  }

  sentOTP(form: FormGroup) {

    var value = this.isMobileNumberTabActive ? form.value.mobile : form.value.email;
    this.mobileNo_Or_Email = this.isMobileNumberTabActive ? form.value.mobile : form.value.email;
    this.otpSentOnText = this.isMobileNumberTabActive ? this.selectedCountryCode + ' ' + form.value.mobile : form.value.email;
    this.otpSentText = this.isMobileNumberTabActive ? ' Mobile Number' : ' Email';

    if (form.valid && value) {
      this.sendVerificationOTP();
    }
  }

  verifyOTP() {
    const headers = { "Content-Type": "application/json" };

    const OTP = this.inputA.nativeElement.value + this.inputB.nativeElement.value + this.inputC.nativeElement.value + this.inputD.nativeElement.value + this.inputE.nativeElement.value + this.inputF.nativeElement.value;
    const bodyParam = {
      "language_code": localStorage.getItem('languageCode'),
      "type": this.isMobileNumberTabActive ? 'mobile' : 'email',
      "isd_code": this.selectedCountryCode,
      "mobile_or_email": this.mobileNo_Or_Email,
      "otp": OTP
    };

    this._apiService.verifyForgotPwdOTP(bodyParam, headers).subscribe(resp => {
      if (resp.success == true) {
        this.VerifyOTPToken = resp.data.token;
        this.getPasswordValidationData();
      }
      else {
        alert(resp.message);
        this.enterOTP = false;
        this.closeModal.emit();
      }
    });
  }

  @Output() childButtonEventLogin = new EventEmitter();

  clickHandler() {
    this.childButtonEventLogin.emit(1);
  }

  isPasswordVisible: boolean = false;
  isPasswordVisibleConfirm: boolean = false;

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  togglePasswordVisibilityConfirm() {
    this.isPasswordVisibleConfirm = !this.isPasswordVisibleConfirm;
  }

  toggleDropdown(event: Event) {
    event.stopPropagation(); // Prevent the click event from reaching parent elements
    this.isOpen = !this.isOpen;
  }

  countryCodeSelect(code: any, event: Event) {
    this.isOpen = false; // Close the dropdown when an option is selected
    this.mobileNoMaxLength = code.mobNo_length;
    this.myForm.get('searchText')?.setValue('');
    this.isCountrySelected = true;
    this.GetCountryList();
    this.selectedCountryCode = code.isd_code;
    this.mobileNoMaxLength = code.mobNo_length;
    this.countryCodeSelected.emit(this.selectedCountryCode); // Emit the selected country code if needed
  }



  showMobileNumberTab() {
    this.isMobileNumberTabActive = true;
    this.isEmailTabActive = false;

    this.myForm.get('mobile')?.setValidators([Validators.required])
    this.myForm.get('mobile')?.updateValueAndValidity();

    this.myForm.get('email')?.clearValidators();
    this.myForm.get('email')?.updateValueAndValidity();
  }

  search() {
    this.GetCountryList();
  }

  showEmailTab() {
    this.isMobileNumberTabActive = false;
    this.isEmailTabActive = true;

    this.myForm.get('email')?.setValidators([Validators.required])
    this.myForm.get('email')?.updateValueAndValidity();

    this.myForm.get('mobile')?.clearValidators();
    this.myForm.get('mobile')?.updateValueAndValidity();
  }

  getPasswordValidationData() {
    this._apiService.getGeneral()
      .subscribe(
        data => {
          let generalData = data.data;

          if (generalData?.PasswordValidation) {
            this.pwdMinLength = generalData?.PasswordValidation[0].minimum_length;
            this.pwdUpperCaseLength = generalData?.PasswordValidation[0].upper_case_characters;
            this.pwdLowerCaseLength = generalData?.PasswordValidation[0].lower_case_characters;
            this.pwdNumericCharLength = generalData?.PasswordValidation[0].numeric_characters;
            this.pwdPsecialCharLength = generalData?.PasswordValidation[0].special_characters;
            this.pwdAlphaNumericharLength = generalData?.PasswordValidation[0].alphanumeric_characters;

            this.myFormPassword.get('password')?.setValidators([
              Validators.required,
              this.passwordPatternValidator(this.pwdMinLength, this.pwdPsecialCharLength, this.pwdAlphaNumericharLength, this.pwdUpperCaseLength, this.pwdLowerCaseLength, this.pwdNumericCharLength)
            ]);

            this.myFormPassword.get('password')?.updateValueAndValidity();


            this.enterOTP = false;
            this.childButtonEventOtpSent.emit('Set New Password');
            this.childButtonEventNewPassword.emit(4);
            this.setNewPassword = true;
          }
        }
      )
  }

  ResetPassword(form: FormGroup) {
    if (form.valid) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.VerifyOTPToken}`,
        }),
      };

      const bodyParam = {
        "language_code": localStorage.getItem('languageCode'),
        "new_password": form.value.password,
        "confirm_password": form.value.confirmPassword
      };

      this._apiService.resetPassword(bodyParam, httpOptions).subscribe(resp => {
        if (resp.success == true) {

          this.closeModal.emit();
        }
        else {
          this.closeModal.emit();
        }
      });
    }
  }

  passwordPatternValidator(minimumLength: number, specialCharLength: number, alphanumericLength: number, upperCaseLength: number, lowerCaseLength: number, numericLength: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value: string = control.value;

      if (!value) {
        // If the value is empty, don't perform validation
        return null;
      }

      // Check minimum length
      if (value.length < minimumLength) {
        return { 'minLength': true };
      }

      // Check special characters
      const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/g;
      if ((value.match(specialCharRegex) || []).length < specialCharLength) {
        return { 'specialChars': true };
      }

      // Check alphanumeric characters
      const alphanumericRegex = /^[a-zA-Z0-9]+$/;
      if ((value.match(alphanumericRegex) || []).length < alphanumericLength) {
        return { 'alphanumericChars': true };
      }

      // Check uppercase characters
      const upperCaseRegex = /[A-Z]/g;
      if ((value.match(upperCaseRegex) || []).length < upperCaseLength) {
        return { 'upperCaseChars': true };
      }

      // Check lowercase characters
      const lowerCaseRegex = /[a-z]/g;
      if ((value.match(lowerCaseRegex) || []).length < lowerCaseLength) {
        return { 'lowerCaseChars': true };
      }

      // Check numeric characters
      const numericRegex = /[0-9]/g;
      if ((value.match(numericRegex) || []).length < numericLength) {
        return { 'numericChars': true };
      }

      // If all conditions are met, return null (no validation error)
      return null;
    };
  }
}
